import * as React from "react";
import { SVGProps } from "react";

const NavMobileToggle = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13"
        fill="none"
        {...props}
    >
        <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.875}
            d="M.95 11.313h13.125m-13.125-5h13.125m-13.125-5h13.125"
            style={{
                stroke: "#000",
                strokeOpacity: 1,
            }}
        />
    </svg>
);

export default NavMobileToggle;
